import * as PIXI from "pixi.js";

export class OpaqueFilter extends PIXI.Filter<any> {

    private static readonly FRAG: string = `
        varying vec2 vTextureCoord;
        uniform sampler2D uSampler;
        uniform float threshold;
        void main(void) {
            vec4 currentColor = texture2D(uSampler, vTextureCoord);
            float alpha = 1.0;
            if (currentColor.a < threshold) {
                alpha = 0.0;
            }
            gl_FragColor = vec4(
                currentColor.r,
                currentColor.g,
                currentColor.b,
                alpha);
        }
    `;

    private readonly _threshold!: number;

    constructor(threshold: number = 0.01) {
        super(undefined, OpaqueFilter.FRAG);
        this.uniforms.threshold = threshold;
        this.padding = 0;
    }
}
